import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SectionHeader from '../../../components/sectionHeader';
import Separator from '../../../components/separator';
import Button from '../../../components/button';
import icon from '../../../icons/GateModule.png';
import styles from './request.module.scss';
import LogTable from './RequestTable';
import { fetchGateRequestLogs } from '../redux/actions';
import Paginator from '../../../components/paginator/paginator';
import Search from '../../../components/search/Search';

const availablePageLimits = [10, 20, 30, 40, 50];

class RequestList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      pageSize: 10
    };
    this.slideStyles = {
      entered: { transform: 'translate3d(0px,0px)' }
    };
  }

  componentDidMount() {
    const { actionFetch } = this.props;
    const { pageSize } = this.state;
    actionFetch(1, pageSize);
  }

  changePage = (page) => {
    const { actionFetch } = this.props;
    const { searchQuery, pageSize } = this.state;
    this.setState({ currentPage: page });
    if (searchQuery) {
      actionFetch(page, pageSize, searchQuery);
      return;
    }
    actionFetch(page, pageSize);
  };

  handleSetPageLimit = (event) => {
    const { actionFetch } = this.props;
    const { searchQuery } = this.state;
    const pageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize, currentPage: 1 });

    if (searchQuery) {
      actionFetch(1, pageSize, searchQuery);
      return;
    }
    actionFetch(1, pageSize);
  };

  handleQuery = (searchQuery) => {
    const { actionFetch } = this.props;
    actionFetch(1, undefined, searchQuery);
  };

  render() {
    const { gateRequests, history } = this.props;
    const { currentPage, pageSize } = this.state;
    return (
  <>
    <SectionHeader
      icon={icon}
      translationID="topbar.gate_change"
      defaultTitle="Gate Change Requests"
    >
      <div className={styles.detailHeader}>
        <Search onSubmit={searchQuery => this.handleQuery(searchQuery)} />
        <Separator />
        <Button action="primary" translationID="gate.new.addBtn" defaultText="New Gate Change Request"
          onClick={() => { history.push('/gate_change/new'); }}
        />
      </div>
    </SectionHeader>
    <br /><br />
    <div className={styles.Container}>
      {gateRequests?.results?.length > 0
      ? (
        <LogTable data={gateRequests?.results} />
      )
      : (
        <span className={styles.spanStyle}>
          <FormattedMessage id="operation.logs_selected_criteria" defaultMessage="There are no requests with the selected criteria." />
        </span>
      )}
      {gateRequests?.results?.length > 0 && (
        <Paginator
          page={currentPage}
          totalRecords={gateRequests?.count}
          pageLimit={pageSize}
          pageNeighbours={1}
          onPageChanged={page => this.changePage(page)}
          handleSetPageLimit={this.handleSetPageLimit}
          availablePageLimits={availablePageLimits}
        />
      )}
    </div>
  </>
    );
  }
}

RequestList.propTypes = {
  history: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => ({
  gateRequests: state.gate.gateRequests,
  RequestListAction: state.gate.RequestListAction
});

const mapDispatchToProps = dispatch => ({
  actionFetch: (page, pageSize, query) => {
    dispatch(fetchGateRequestLogs(page, pageSize, query));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RequestList);
